import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import {
	ContentRecommendation,
	EmptyLoadingElement,
} from '@/components/content/ContentRecommendation';
import { Box, Stack } from '@mui/material';
import React from 'react';

const emsName = 'DPV2FooterDPLogos';

const dpstreetSrc = '/dpstreetLogos.png';

const dportenisSrc = '/dportenisLogos.png';

interface DpLogosMobileProps {
	breakToMobileFooter: boolean;
}

export const DpLogosMobile: React.FC<DpLogosMobileProps> = ({ breakToMobileFooter }) => (
	<Stack>
		<Stack direction="row" gap={'9px'}>
			<a href="https://www.dpstreet.mx" target="_blank" rel="noopener noreferrer">
				<Img
					sx={{
						height: '26px !important',
						width: '100px',
						objectFit: 'cover',
					}}
					src={dpstreetSrc}
					alt="dpstreet"
				/>
			</a>
			<a href="https://www.dportenis.mx" target="_blank" rel="noopener noreferrer">
				<Img
					sx={{ height: '26px !important', width: '100px', objectFit: 'cover' }}
					src={dportenisSrc}
					alt="dportenis"
				/>
			</a>
		</Stack>
		<Box display={'flex'} gap={'4px'} alignItems={'center'}>
			<Linkable
				id="Localizador-Link"
				href="/localizador-de-tiendas"
				sx={{
					fontSize: { xs: 'var(--font-size-sm)', sm: 'var(--font-size-default)' },
					fontWeight: 'bold',
					textTransform: 'uppercase',
					marginTop: breakToMobileFooter ? '14px' : '26px',
					marginBottom: '10px',
				}}
				target="_blank"
				rel="noopener noreferrer"
			>
				{'ENCUENTRA TU TIENDA'}
			</Linkable>
			<Box sx={{ marginBottom: '10px', marginTop: breakToMobileFooter ? '14px' : '26px' }}>
				{'|'}
			</Box>
			<Linkable
				id="Localizador-Link"
				href="/centro-de-ayuda"
				sx={{
					fontSize: { xs: 'var(--font-size-sm)', sm: 'var(--font-size-default)' },
					fontWeight: 'bold',
					textTransform: 'uppercase',
					marginTop: breakToMobileFooter ? '14px' : '26px',
					marginBottom: '10px',
				}}
				target="_blank"
				rel="noopener noreferrer"
			>
				{'CENTRO DE AYUDA'}
			</Linkable>
		</Box>
	</Stack>
);

export const DpLogos = () => (
	<ContentRecommendation
		id={`footer-${emsName}`}
		properties={{ emsName }}
		loadingElement={<EmptyLoadingElement />}
	/>
);
